import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { request } from "@/api/client";

export const AuditLogRowSchema = z.object({
  id: z.number().int(),
  admin_tg_id: z.number().int().nullable(),
  admin_user_id: z.number().int().nullable().optional(),
  action: z.string(),
  target_user_id: z.number().int().nullable(),
  target_payment_id: z.number().int().nullable(),
  payload: z.record(z.unknown()).nullable(),
  created_at: z.string(),
});
export type AuditLogRow = z.infer<typeof AuditLogRowSchema>;
export const AuditLogListSchema = z.array(AuditLogRowSchema);

export interface AuditLogFilters {
  limit?: number;
  action?: string;
  adminTgId?: number;
  since?: string;
}

function buildQS(f: AuditLogFilters): string {
  const params = new URLSearchParams();
  params.set("limit", String(f.limit ?? 200));
  if (f.action) params.set("action", f.action);
  if (f.adminTgId !== undefined) params.set("admin_tg_id", String(f.adminTgId));
  if (f.since) params.set("since", f.since);
  return params.toString();
}

export function useAuditLogs(filters: AuditLogFilters) {
  return useQuery({
    queryKey: ["admin", "audit-logs", filters],
    queryFn: ({ signal }) =>
      request({
        path: `/api/admin/audit-logs?${buildQS(filters)}`,
        schema: AuditLogListSchema,
        signal,
      }),
  });
}
